import React, { CSSProperties, useEffect, useState } from "react";
import {
  Button,
  Form,
  ImageUploader,
  Input,
  List,
  Picker,
  Popup,
  TextArea,
  Toast,
  Image,
  Space,
  ActionSheet,
  Dialog,
  CheckList,
  Tag,
  Card,
} from "antd-mobile";
import {
  saveAncientInfo,
  queryDictionaryItemById,
  queryPlant,
  queryPlantById,
  queryAncientInfoById,
  queryRoad,
} from "./service";
import { ImageUploadItem } from "antd-mobile/es/components/image-uploader";
import { locationChange, FileUpload } from "../../services/index";
import { useNavigate, useLocation } from "react-router-dom";
import type { Action } from "antd-mobile/es/components/action-sheet";
import { WX_APPID } from "../../config";
import { isAndroid } from "../../utils/deviceUtils";
import storageUtil from "../../utils/storageUtil";
import { wxsign } from "../../services/index";
import { AddCircleOutline } from 'antd-mobile-icons'
const wx = require("weixin-js-sdk");

interface IPicker {
  label: string;
  value: string;
}
const TreeCreateScreen: React.FC = React.memo(() => {
  const navigation = useNavigate();
  const location = useLocation();
  const id: any = location.state;
  const [form] = Form.useForm();
  const [current, setCurrent] = useState<
    Partial<APIGarden.AncientItem> | undefined
  >(undefined);
  const [treeTypeVisible, setTreeTypeVisible] = useState(false);
  const [ownershipVisible, setOwnershipVisible] = useState(false);
  const [treeLevelVisible, setTreeLevelVisible] = useState(false);
  const [slopeVisible, setSlopeVisible] = useState(false);
  const [growthVigorVisible, setGrowthVigorVisible] = useState(false);
  const [growingEnvironmentVisible, setGrowingEnvironmentVisible] =
    useState(false);
  const [roadVisible, setRoadVisible] = useState(false);
  const [treeType, setTreeType] = useState<APICommon.DictionaryItem[]>([]);
  const [TreeLevelDic, setTreeLevelDic] = useState<IPicker[]>([]);
  const [ownershipDic, setOwnershipDic] = useState<IPicker[]>([]);
  const [slopeDic, setSlopeDic] = useState<IPicker[]>([]);
  const [growthVigorDic, setGrowthVigorDic] = useState<IPicker[]>([]);
  const [growingEnvironmentDic, setGrowingEnvironmentDic] = useState<IPicker[]>(
    []
  );
  const [roadInfo, setRoadInfo] = useState<IPicker[]>([]);
  const [plant, setPlants] = useState<APIGarden.PlantItem[]>([]);
  const [popupVisible, setPopupVisible] = useState(false);
  const [ancientId, setAncientId] = useState<string>("");
  const [files, setFiles] = useState<ImageUploadItem[]>([]);
  const [fileList, setFileList] = useState<APICommon.FileItem[]>([]);
  const [type, setType] = useState<string[]>([]);
  const [ownership, setOwnership] = useState<string>("");
  const [slope, setSlope] = useState<string>("");
  const [growthVigor, setGrowthVigor] = useState<string>("");
  const [growingEnvironment, setGrowingEnvironment] = useState<string>("");
  const [level, setLevel] = useState<string>("");
  const [roadName, setRoadName] = useState<string>("");
  const [sheetVisible, setSheetVisible] = useState(false);
  const [imgIndex, setImgIndex] = useState<number>(0);
  const [url, setUrl] = useState("");
  const [typeIds, setTypeIds] = useState<string[]>([]);
  const [ancientTypes, setAncientTypes] = useState<APIGarden.AncientTypeItem[]>([]);
  const [companyDic, setCompanyDic] = useState<IPicker[]>([]);
  const [comoanyVisible, setComoanyVisible] = useState(false);
  const [companyName, setCompanyName] = useState<string>("");
  const [isAdmin, setIsAdmin] = useState<boolean>(false);

  useEffect(() => {
    const init = async () => {
      const signUrl = isAndroid()
        ? window.location.href
        : await storageUtil.getItem("INDEX_URL", false);
      setUrl(signUrl);
    };
    init();
  }, []);


  useEffect(() => {
    setFileList([]);
    if (url) {
      wxsign(url)
        .then((data) => {
          if (data) {
            // 通过config接口注入权限验证配置
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: WX_APPID, // 必填，公众号的唯一标识
              timestamp: data.timestamp, // 必填，生成签名的时间戳
              nonceStr: data.nonceStr, // 必填，生成签名的随机串
              signature: data.signature, // 必填，签名
              jsApiList: ["getLocation"], // 必填，需要使用的JS接口列表
            });
            wx.error(function (e: any) {
              // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
              // message.error("签名失败，请检查微信版本");
              Toast.show({
                content: "获取微信签名失败",
                afterClose: () => { },
              });
            });
          }
        })
        .catch((error) => {
          Toast.show({
            content: "获取微信签名失败",
            afterClose: () => { },
          });
        });
    }
    if (id) {
      queryAncientInfoById(id).then((data) => {
        if (data) {
          setCurrent(data.obj);
          form.setFieldsValue({
            ...data.obj,
          });
          if (data.obj.ancientType) {
            queryDictionaryItemById("918573067934892032").then((res) => {
              const typeData: string[] = [];
              if (res && res.list) {
                data.obj.ancientType.map((type: any) => (
                  res.list.map((item: any) => {
                    if (type.typeId === item.id) {
                      typeData.push(item.dictName)
                    }
                  })
                ))
              }
              setType(typeData);
            });
            const ids: string[] = [];
            data.obj.ancientType?.map((item: any) => {
              if (item.typeId) {
                ids.push(item.typeId);
              }
            });
            setTypeIds(ids);
          }
          setOwnership(data.obj.ownershipName);
          setSlope(data.obj.slopeName);
          setGrowthVigor(data.obj.growthVigorName);
          setGrowingEnvironment(data.obj.growingEnvironmentName);
          setLevel(data.obj.levelName);
          setRoadName(data.obj.roadName);
          if (data.obj.managementUnitName) setCompanyName(data.obj.managementUnitName);
          if (data.obj.files) setFileList(data.obj.files);
          if (data.obj.roleUsers.length > 0) {
            data.obj.roleUsers.map((item: any) => {
              if (item.roleName === '超级管理员') {
                setIsAdmin(true);
              }
            })
          }
        }
      });
    } else {
      form.resetFields();
      setIsAdmin(true);
    }
    //获取名木类型
    queryDictionaryItemById("918573067934892032").then((data) => {
      if (data && data.list) {
        setTreeType(data.list);
      }
    });
    //获取养护等级
    queryDictionaryItemById("918574759061487616").then((data) => {
      if (data) {
        const typeData: IPicker[] = [];
        data.list.map((type: any) => {
          typeData.push({ label: type.dictName, value: type.id });
        });
        setTreeLevelDic(typeData);
      }
    });

    //获取权属
    queryDictionaryItemById("918575420264153088").then((data) => {
      if (data) {
        const typeData: IPicker[] = [];
        data.list.map((type: any) => {
          typeData.push({ label: type.dictName, value: type.id });
        });
        setOwnershipDic(typeData);
      }
    });

    //获取坡度
    queryDictionaryItemById("918576126371037184").then((data) => {
      if (data) {
        const typeData: IPicker[] = [];
        data.list.map((type: any) => {
          typeData.push({ label: type.dictName, value: type.id });
        });
        setSlopeDic(typeData);
      }
    });

    //获取生长势
    queryDictionaryItemById("918577362432425984").then((data) => {
      if (data) {
        const typeData: IPicker[] = [];
        data.list.map((type: any) => {
          typeData.push({ label: type.dictName, value: type.id });
        });
        setGrowthVigorDic(typeData);
      }
    });

    //获取生长环境
    queryDictionaryItemById("918577549427081216").then((data) => {
      if (data) {
        const typeData: IPicker[] = [];
        data.list.map((type: any) => {
          typeData.push({ label: type.dictName, value: type.id });
        });
        setGrowingEnvironmentDic(typeData);
      }
    });
    // 获取路段信息
    queryRoad('0', 1, 10000).then((data: any) => {
      if (data.success && data.data) {
        const typeData: IPicker[] = [];
        data.data.map((item: any) => (
          typeData.push({ label: item.roadName, value: item.id })
        ));
        setRoadInfo(typeData);
      }
    });
    //获取单位数据字典信息
    queryDictionaryItemById("934127824892067840").then((data) => {
      if (data) {
        const typeData: IPicker[] = [];
        data.list.map((type: any) => {
          typeData.push({ label: type.dictName, value: type.id });
        });
        setCompanyDic(typeData);
      }
    });
  }, [id, form, url]);

  // 处理编辑页面保存回调事务
  const handleSave = async (values: APIGarden.AncientItem) => {
    try {
      const resp = await saveAncientInfo({ ...values });
      if (resp.obj) {
        Toast.show({
          icon: "success",
          content: "提交成功",
        });
        navigation("/tree/list");
      } else {
        Toast.show({
          icon: "fail",
          content: "提交失败，请重试！",
        });
      }
      return true;
    } catch (error) {
      Toast.show({
        icon: "fail",
        content: "提交失败，请重试！",
      });
      return false;
    }
  };

  const onFinish = (values: any) => {
    values.files = fileList;
    values.plantId = ancientId;
    values.ancientType = ancientTypes;
    handleSave({
      ...current,
      ...values,
    });
    //重置表单
    form.resetFields();
    setType([]);
    setRoadName("");
    setOwnership("");
    setGrowthVigor("");
    setLevel("");
    setGrowingEnvironment("");
    setSlope("");
    setFiles([]);
    setCompanyName("");
    // if (onSubmit) {
    //   onSubmit();
    // }
  };

  //获取植物库信息
  const showPopup = () => {
    queryPlant().then((data) => {
      if (data && data.list) {
        setPlants(data.list);
        setPopupVisible(true);
      }
    });
  };

  const getPlant = (id: string) => {
    setAncientId(id);
    queryPlantById(id).then((data) => {
      if (data && data.obj) {
        form.setFieldsValue({
          treeSpecies: data.obj.name,
          latin: data.obj.synonym,
          alias: data.obj.alias,
          family: data.obj.sectionName,
          category: data.obj.category,
          features: data.obj.remark,
          purpose: data.obj.economicValue,
        });
      }
    });
    setPopupVisible(false);
  };
  // //设置权属
  const setOwnershipId = (label: any, value: any) => {
    setOwnership(label);
    form.setFieldsValue({
      ownershipId: value,
    });
  };
  //设置坡度
  const setSlopeId = (label: any, value: any) => {
    setSlope(label);
    form.setFieldsValue({
      slopeId: value,
    });
  };
  // //设置生长势
  const setGrowthVigorId = (label: any, value: any) => {
    setGrowthVigor(label);
    form.setFieldsValue({
      growthVigorId: value,
    });
  };
  // //设置生长环境
  const setGrowingEnvironmentId = (label: any, value: any) => {
    setGrowingEnvironment(label);
    form.setFieldsValue({
      growingEnvironmentId: value,
    });
  };
  // //设置养护等级
  const setLevelId = (label: any, value: any) => {
    setLevel(label);
    form.setFieldsValue({
      levelId: value,
    });
  };

  // //设置路段信息
  const setRoadId = (label: any, value: any) => {
    setRoadName(label);
    form.setFieldsValue({
      roadId: value,
    });
  };

  const setCompanyInfo = (label: any, value: any) => {
    setCompanyName(label);
    form.setFieldsValue({
      managementUnit: value,
    });
  };
  //上传附件
  const mockUpload = async (file: File) => {
    const formData = new FormData();
    if (file) {
      formData.append("file", file);
      formData.append("type", "/ancient/info");
      const result = await FileUpload(formData);
      if (result) {
        fileList.push({
          id: result.list[0].uid,
          linkType: "树木图片",
          fileName: result.list[0].originalName,
          fileExt: result.list[0].contentType,
          fileSize: result.list[0].fileSize,
          filePath: result.list[0].filePath,
          filePathFull: result.list[0].filePathFull,
          gmtCreate: result.list[0].uploadDate,
        });
        setFileList([...fileList]);
      }
    }
    return {
      url: URL.createObjectURL(file),
    };
  };

  const uploadFile = (fileInfo: ImageUploadItem[]) => {
    setFiles(fileInfo);
  };

  //获取定位数据
  const getAddress = () => {
    wx.getLocation({
      type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      success: function (res: any) {
        if (res) {
          locationChange(res.longitude, res.latitude).then((data: any) => {
            if (data && data.list) {
              form.setFieldsValue({
                longitude: data.list[0].x,
                latitude: data.list[0].y,
              });
            } else {
              Toast.show({
                content: "获取经纬度失败",
                afterClose: () => { },
              });
            }
          });
        } else {
          Toast.show({
            content: "获取经纬度失败",
            afterClose: () => { },
          });
        }
      },
    });
  };


  //删除图片操作
  const sheet = (index: number) => {
    setSheetVisible(true);
    setImgIndex(index);
  };
  const actions: Action[] = [
    {
      text: "删除",
      key: "delete",
      description: "删除后数据不可恢复",
      danger: true,
      onClick: async () => {
        const result = await Dialog.confirm({ content: "确定要删除吗？" });
        if (result) {
          fileList.splice(imgIndex, 1);
          setFileList(fileList);
          setSheetVisible(false);
        }
      },
    },
    {
      text: "取消",
      key: "cancel",
      onClick: async () => {
        setSheetVisible(false);
      },
    },
  ];

  const selectTreeType = (values: string[]) => {
    const data: string[] = [];
    const typeData: APIGarden.AncientTypeItem[] = []
    values.map((item) => (
      treeType.map((type) => {
        if (item === type.id) {
          data.push(type.dictName ? type.dictName : '');
        }
      })
    ));
    values.map((val) => (
      typeData.push({ typeId: val })
    ));
    setType(data);
    setAncientTypes(typeData);
  };

  const getModalContent = () => {
    return (
      <div style={container}>
        <Form
          form={form}
          onFinish={onFinish}
          layout="horizontal"
          mode="card"
          footer={
            <div>
              {
                isAdmin && (
                  <Button
                    block
                    type="submit"
                    color="primary"
                    size="large"
                    style={submitBut}
                  >
                    提交
                  </Button>
                )
              }
            </div>
          }
        >
          {id && (
            <Button
              style={{ width: '100%', color: '#1677ff' }}
              onClick={() => navigation(`/inspect/create/${id}`)}
            >
              <AddCircleOutline /> 巡查填报
            </Button>
          )}
          <Form.Header>树木信息</Form.Header>
          <Form.Item
            // name="typeId"
            label="树木类型"
            rules={[{ required: true, message: "树木类型不能为空" }]}
            onClick={() => {
              setTreeTypeVisible(true);
            }}
          >
            <Popup
              visible={treeTypeVisible}
              onMaskClick={() => {
                setTreeTypeVisible(false);
              }}
              bodyStyle={{ height: "40vh" }}
            >
              <CheckList
                multiple
                defaultValue={typeIds}
                onChange={(val) => { selectTreeType(val) }}
              >
                {
                  treeType.map((item) => (
                    <CheckList.Item value={item.id ? item.id : ''}>{item.dictName}</CheckList.Item>
                  ))
                }
              </CheckList>
            </Popup>
            {type.length > 0 ? type.map((item) =>
              <Tag
                fill='outline'
                style={{
                  '--border-color': 'var(--adm-color-weak)',
                  height: '25px',
                  fontSize: '16px',
                  lineHeight: '20px'
                }}
              >
                {item}
              </Tag>) : "请选择树木类型"
            }
          </Form.Item>
          <Form.Item
            name="number"
            label="树木牌号"
            rules={[{ required: true, message: "树木牌号不能为空" }]}
          >
            <Input type="number" placeholder="请填写树木牌号" />
          </Form.Item>
          <Form.Item
            name="treeSpecies"
            label="树种"
            onClick={() => showPopup()}
            rules={[{ required: true, message: "树种不能为空" }]}
          >
            <Input placeholder="请选择树种" readOnly />
          </Form.Item>

          <Form.Header />
          <Form.Item name="latin" label="拉丁名">
            <Input />
          </Form.Item>
          <Form.Item name="alias" label="别名">
            <Input />
          </Form.Item>
          <Form.Item name="family" label="科">
            <Input />
          </Form.Item>
          <Form.Item name="category" label="属">
            <Input />
          </Form.Item>
          <Form.Header>树木特征</Form.Header>
          <Form.Item
            name="street"
            label="街道"
            rules={[{ required: true, message: "请输入街道" }]}
          >
            <Input placeholder="请输入街道" />
          </Form.Item>
          <Form.Item name="streetOffices" label="居委">
            <Input placeholder="请输入居委" />
          </Form.Item>
          <Form.Item
            name="ownershipId"
            label="权属"
            onClick={() => {
              setOwnershipVisible(true);
            }}
            rules={[{ required: true, message: "请选择权属" }]}
          >
            <Picker
              columns={[ownershipDic]}
              visible={ownershipVisible}
              onClose={() => {
                setOwnershipVisible(false);
              }}
              onConfirm={(v, e) =>
                e.items.map((item) => setOwnershipId(item?.label, item?.value))
              }
            />
            {ownership ? ownership : "请选择权属"}
          </Form.Item>
          <Form.Item
            name="roadId"
            label="路段"
            onClick={() => {
              setRoadVisible(true);
            }}
            rules={[{ required: true, message: "请选择路段" }]}
          >
            <Picker
              columns={[roadInfo]}
              visible={roadVisible}
              onClose={() => {
                setRoadVisible(false);
              }}
              onConfirm={(v, e) =>
                e.items.map((item) => setRoadId(item?.label, item?.value))
              }
            />
            {roadName ? roadName : "请选择路段"}
          </Form.Item>
          <Form.Item
            name="placeName"
            label="位置"
            extra={
              <div onClick={() => getAddress()} style={{ color: '#1677ff' }}>
                获取经纬度
              </div>
            }
            rules={[{ required: true, message: "请先获取位置信息" }]}
          >
            <Input placeholder="点击获取位置信息" />
          </Form.Item>

          <Form.Item name="longitude" label="经度">
            <Input
              type="number"
              placeholder="请输入经度"
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item name="latitude" label="纬度">
            <Input
              type="number"
              placeholder="请输入纬度"
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item name="treeHeight" label="树高(m)">
            <Input
              type="number"
              placeholder="请输入树高"
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item
            name="chest"
            label="胸径(cm)"
            rules={[{ required: true, message: "请输入胸径" }]}
          >
            <Input
              type="number"
              placeholder="请输入胸径"
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item name="eastWest" label="东西">
            <Input
              type="number"
              placeholder="请输入东西"
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item name="northSouth" label="南北">
            <Input
              type="number"
              placeholder="请输入南北"
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item name="average" label="平均">
            <Input
              type="number"
              placeholder="请输入平均"
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item name="exposure" label="坡向">
            <Input placeholder="请输入坡向" />
          </Form.Item>
          <Form.Item
            name="slopeId"
            label="坡度"
            onClick={() => {
              setSlopeVisible(true);
            }}
          >
            <Picker
              columns={[slopeDic]}
              visible={slopeVisible}
              onClose={() => {
                setSlopeVisible(false);
              }}
              onConfirm={(v, e) =>
                e.items.map((item) => setSlopeId(item?.label, item?.value))
              }
            />
            {slope ? slope : "请选择坡度"}
          </Form.Item>
          <Form.Item name="slopePosition" label="坡位">
            <Input placeholder="请输入坡位" />
          </Form.Item>
          <Form.Item name="soilType" label="土壤类型">
            <Input placeholder="请输入土壤类型" />
          </Form.Item>
          <Form.Item name="soilDensity" label="土壤紧实度">
            <Input placeholder="请输入土壤紧实度" />
          </Form.Item>
          <Form.Item
            name="growthVigorId"
            label="生长势"
            onClick={() => {
              setGrowthVigorVisible(true);
            }}
          >
            <Picker
              columns={[growthVigorDic]}
              visible={growthVigorVisible}
              onClose={() => {
                setGrowthVigorVisible(false);
              }}
              onConfirm={(v, e) =>
                e.items.map((item) =>
                  setGrowthVigorId(item?.label, item?.value)
                )
              }
            />
            {growthVigor ? growthVigor : "请选择生长势"}
          </Form.Item>
          <Form.Item
            name="growingEnvironmentId"
            label="生长环境"
            onClick={() => {
              setGrowingEnvironmentVisible(true);
            }}
          >
            <Picker
              columns={[growingEnvironmentDic]}
              visible={growingEnvironmentVisible}
              onClose={() => {
                setGrowingEnvironmentVisible(false);
              }}
              onConfirm={(v, e) =>
                e.items.map((item) =>
                  setGrowingEnvironmentId(item?.label, item?.value)
                )
              }
            />
            {growingEnvironment ? growingEnvironment : "请选择生长环境"}
          </Form.Item>
          <Form.Item
            name="levelId"
            label="养护等级"
            onClick={() => {
              setTreeLevelVisible(true);
            }}
          >
            <Picker
              columns={[TreeLevelDic]}
              visible={treeLevelVisible}
              onClose={() => {
                setTreeLevelVisible(false);
              }}
              onConfirm={(v, e) =>
                e.items.map((item) => setLevelId(item?.label, item?.value))
              }
            />
            {level ? level : "请选择养护等级"}
          </Form.Item>
          <Form.Item name="age" label="树龄(年)">
            <Input
              type="number"
              placeholder="请输入树龄"
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item name="features" label="树木描述">
            <TextArea readOnly />
          </Form.Item>
          <Form.Item name="purpose" label="经济价值">
            <TextArea readOnly />
          </Form.Item>
          <Form.Header>树木保护</Form.Header>
          <Form.Item
            name="ownershipUnit"
            label="权属单位"
            rules={[{ required: true, message: "请输入权属单位" }]}
          >
            <Input placeholder="请输入权属单位" />
          </Form.Item>
          <Form.Item
            name="manageCompany"
            label="管理单位"
            rules={[{ required: true, message: "请输入管理单位" }]}
          >
            <Input placeholder="请输入管理单位" />
          </Form.Item>
          <Form.Item
            name="companyPhone"
            label="单位联系电话"
            rules={[{ required: true, message: "请输入单位联系电话" }]}
          >
            <Input placeholder="请输入单位联系电话" />
          </Form.Item>
          <Form.Item
            name="managementUnit"
            label="养护单位"
            onClick={() => setComoanyVisible(true)}
            rules={[{ required: companyName === "", message: "请选择养护单位" }]}
          >
            <Picker
              columns={[companyDic]}
              visible={comoanyVisible}
              onClose={() => {
                setComoanyVisible(false);
              }}
              onConfirm={(v, e) =>
                e.items.map((item) => setCompanyInfo(item?.label, item?.value))
              }
            />
            {companyName ? companyName : "请选择养护单位"}
          </Form.Item>
          <Form.Item
            name="caretaker"
            label="管护人"
            rules={[{ required: true, message: "请输入管护人" }]}
          >
            <Input placeholder="请输入管护人" />
          </Form.Item>
          <Form.Item
            name="linkPhone"
            label="联系电话"
            rules={[{ required: true, message: "请输入联系电话" }]}
          >
            <Input placeholder="请输入联系电话" />
          </Form.Item>
          <Form.Item name="ancientHistory" label="树木历史">
            <TextArea placeholder="树木历史" />
          </Form.Item>
          <Form.Item name="protect" label="地上保护现状">
            <TextArea placeholder="请输入地上保护现状" />
          </Form.Item>
          <Form.Header>{current?.files && "植物图片"}</Form.Header>
          {current?.files &&
            fileList.map((item, index) => (
              <Space
                style={{ padding: "15px" }}
                onClick={() => {
                  sheet(index);
                }}
              >
                <Image
                  src={item.filePathFull ? item.filePathFull : ""}
                  style={{ borderRadius: 4 }}
                  width={70}
                  height={70}
                />
              </Space>
            ))}
          <Form.Header>上传图片</Form.Header>
          <Form.Item style={{ height: "120px" }}>
            <ImageUploader
              style={{ "--cell-size": "70px" }}
              value={files}
              onChange={(fileList) => {
                uploadFile(fileList);
              }}
              upload={mockUpload as any}
            />
          </Form.Item>
        </Form>
        <ActionSheet
          visible={sheetVisible}
          actions={actions}
          onClose={() => setSheetVisible(false)}
        />
        <Popup
          visible={popupVisible}
          onMaskClick={() => {
            setPopupVisible(false);
          }}
          bodyStyle={{ height: "40vh" }}
        >
          <div style={{ height: "40vh", overflowY: "scroll", padding: "20px" }}>
            <List header="选择所属植物信息">
              {plant.map((plant) => (
                <List.Item
                  arrow={false}
                  key={plant.id}
                  description={plant.alias}
                  onClick={() => getPlant(plant.id ? plant.id : "")}
                >
                  {plant.name}
                </List.Item>
              ))}
            </List>
          </div>
        </Popup>
      </div>
    );
  };
  return (
    <div>
      {getModalContent()};
    </div>
  )
});

const container: CSSProperties = {
  backgroundColor: "#f5f7fa",
};
const submitBut: CSSProperties = {
  marginTop: "50px",
  position: "fixed",
  bottom: 15,
  width: "94%",
};
export default TreeCreateScreen;
